var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLibrary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.655 2.223a.85.85 0 0 1 .69 0l9 4a.85.85 0 1 1-.69 1.554L12 3.93 3.345 7.777a.85.85 0 0 1-.69-1.554zM2.15 10c0-.47.38-.85.85-.85h18a.85.85 0 0 1 0 1.7h-.15v9.3H21a.85.85 0 0 1 0 1.7H3a.85.85 0 0 1 0-1.7h.15v-9.3H3a.85.85 0 0 1-.85-.85m2.7.85v9.3h14.3v-9.3zM8 13.15c.47 0 .85.38.85.85v3a.85.85 0 0 1-1.7 0v-3c0-.47.38-.85.85-.85m4 0c.47 0 .85.38.85.85v3a.85.85 0 0 1-1.7 0v-3c0-.47.38-.85.85-.85m4 0c.47 0 .85.38.85.85v3a.85.85 0 0 1-1.7 0v-3c0-.47.38-.85.85-.85",
  clipRule: "evenodd"
})));
export default SvgLibrary;